// extracted by mini-css-extract-plugin
export var clear = "styles-module--clear--w-oKi";
export var thumb = "styles-module--thumb---Tiap";
export var wrapper = "styles-module--wrapper--rF5vu";